<template>
    <div class="mx-auto mt-md-3 mt-sm-0">
        <div class="personLoading"></div>
        <div v-if="!personLoading && personLoaded">
            <div v-if="personModel">
                <div>
                    <PersonDetailsCard v-model="personModel"
                                       :allowEdit="!details"
                                       :hideCloseBtn="true"
                                       @edit="onEditClicked">
                    </PersonDetailsCard>
                </div>

                <div v-if="showPersonHistoryData" class="mt-md-2 mt-sm-0">
                    <HistoryRecordsGrid :id="personId ? personId : personModel.id"
                                        :url="'api/history/person'"
                                        :columns="personHistoryGridColumns"
                                        :schemaModelFields="personHistoryGridSchemaModelFields"
                                        :componentName="'PersonHistory'">
                    </HistoryRecordsGrid>
                </div>
            </div>
            <div v-else>
                <div class="btn-group">
                    <div class="btn btn-primary" @click.stop="onCreateClick"><i class="far fa-plus-square"></i>{{ $t('buttons.create.btnText')}}</div>
                </div>
            </div>
        </div>


        <CreateModal :show="showCreate" :profileManagement="true" @onCreate="onCreate" @onClose="onCreateClose"></CreateModal>
        <EditModal v-model="personModel" :show="showEdit" :profileManagement="true" show-en-names @onClose="onEditClose" @onSave="onPersonEdit"></EditModal>
    </div>
</template>

<script>
    import { Person } from '@/models/models';
    import EditModal from '@/components/person/edit.modal';
    import CreateModal from '@/components/person/create.modal';
    import PersonDetailsCard from '@/components/person/PersonDetailsCard';
    import HistoryRecordsGrid from '@/components/history/HistoryRecordsGrid';
    import personService from '@/services/person.service';
    import userService from '@/services/user.service';
    import { personHistoryGridColumns, personHistoryGridSchemaModelFields } from '@/settings/historyGridsSettings'

    export default {
        inject: ['$validator'],
        props: {
            userId: {
                type: String,
                required: true,
                default: null
            },
            personId: {
                type: Number,
                default: 0
            },
            details: {
                type: Boolean,
                default: false
            },
            showPersonHistoryData: {
                type: Boolean,
                default: false
            }
        },
        components: {
            EditModal,
            CreateModal,
            PersonDetailsCard,
            HistoryRecordsGrid
        },
        data() {
            return {
                personLoading: false,
                personLoaded: false,
                personModel: null,
                showEdit: false,
                showCreate: false,
                personHistoryGridColumns: personHistoryGridColumns,
                personHistoryGridSchemaModelFields: personHistoryGridSchemaModelFields
            };
        },
        created() {

        },
        mounted() {
            this.refresh();
        },
        methods: {
            loadPersonDetails(id) {
                this.personLoading = true;
                personService
                    .getById(id)
                    .then(response => {
                        let model = response.data;
                        if (model) {
                            this.personModel = new Person(model);
                        } else {
                            this.personModel = null;
                        }

                        this.personLoaded = true;
                        this.personLoading = false;
                    })
                    .catch(error => {
                        this.personModel = null;
                        this.personLoaded = true;
                        this.personLoading = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            loadCurrentUserPerson(id) {
                this.personLoading = true;
                personService
                    .getByUserId(id)
                    .then(response => {
                        let model = response.data;
                        if (model) {
                            this.personModel = new Person(model);
                        } else {
                            this.personModel = null;
                        }

                        this.personLoaded = true;
                        this.personLoading = false;
                    })
                    .catch(error => {
                        this.personModel = null;
                        this.personLoaded = true;
                        this.personLoading = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            mapPersonToUser(personId) {
                this.personLoading = true;

                userService
                    .addMasterPerson(this.userId, personId)
                    .then(response => {
                        this.personLoading = false;
                        this.refresh();
                    })
                    .catch(error => {
                        this.personLoading = false;
                        this.refresh();

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            onCreateClick() {
                if (this.details) {
                    return;
                }
                this.showCreate = true;
            },
            onCreateClose() {
                this.showCreate = false;
            },
            onEditClose() {
                this.showEdit = false;
            },
            onCreate(model) {
                this.mapPersonToUser(model.id)
            },
            onPersonEdit(item) {
                this.refresh();
            },
            onEditClicked(item) {
                if (this.details) {
                    return;
                }

                this.showEdit = true;
            },
            refresh() {
                if (this.isDetailsReview) {
                    this.loadPersonDetails(this.personId);
                } else {
                    this.loadCurrentUserPerson(this.userId)
                }
            }
        },
        computed: {
            isDetailsReview() {
                return this.details && this.personId > 0;
            }
        }
    };
</script>

<style scoped>
</style>
